import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Loading fallback component for Suspense boundaries
 * Displays a centered loading spinner while lazy components are loading
 */
export const LoadingFallback = (props: { className?: string }) => {
  const { className } = props;
  return (
    <div
      className={cn(
        'animate-in fade-in-0 fill-mode-backwards flex size-full min-h-0 items-center justify-center delay-300 duration-200',
        className,
      )}
    >
      <Loader2 className="text-muted-foreground size-6 animate-spin" />
    </div>
  );
};
